import { ErrorHandler, Injectable } from '@angular/core';
import { LoggerService } from '@ui-kit';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(
    private logger: LoggerService,
  ) {}

  handleError(error: any) {
    this.logger.report(error.rejection || error);
  }
}
